import * as CubeTree from '../cubeTree/index';
import { add } from './set';
import { clear } from './delete';

export function init(stageCube: CubeNode): void {
    clear();
    stageCube.walk((cube: CubeNode): void => {
        if (CubeTree.isSketchpad(cube.id)
            || CubeTree.isCabinet(cube.id)) {
            return;
        }

        add(cube.id);
    });
}
